import React, { useEffect, useState } from 'react';
import { login  } from '../../Services/authService';
import { getProfile  } from '../../Services/userProfile';
import { Link, useNavigate } from 'react-router-dom';


const Login = ({ setUser }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Clear user data when the login page is loaded
    useEffect(() => {
        localStorage.removeItem('user');
        localStorage.removeItem('profilePic');
        localStorage.clear();
        sessionStorage.clear();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const credentials = { username, password };
            const data = await login(credentials);
    
            // Store user details (e.g., token, role, username)
            const { id, role } = data;
            localStorage.setItem('user', JSON.stringify(data));
            localStorage.setItem('role', role);
    
            setUser(data);
    
            // Fetch profile data
            const profileData = await getProfile(id);
            if (profileData && profileData.profileImage) {
                localStorage.setItem('profilePic', profileData.profileImage);
                setUser((prev) => ({
                    ...prev,
                    profilePic: profileData.profileImage,
                }));
            }
            if(role=="Admin"){
            // Navigate to the dashboard
            navigate('/allcreditcard');
            }else{
                navigate('/applycreditcard');
            }
        } catch (error) {
            console.error('Login failed:', error);
            setError('Login failed. Please check your credentials.');
        }
    };

    
    return (
        <div>
            <div className="auth-fluid">
                {/*Auth fluid left content */}
                <div className="auth-fluid-form-box">
                    <div className="card-body d-flex flex-column h-100 gap-3">
                        {/* Logo */}
                        <div className="auth-brand text-center text-lg-start">
                            <Link to="/" className="logo-dark">
                                <span><img src="assets/images/logo-dark.png" alt="dark logo" height={42} /></span>
                            </Link>
                            <a href="index.html" className="logo-light">
                                <span><img src="assets/images/logo.png" alt="logo" height={42} /></span>
                            </a>
                        </div>
                        <div className="my-auto">
                            {/* title*/}
                            <h4 className="mt-0">Sign In</h4>
                            <p className="text-muted mb-4">Enter your email address and password to access account.</p>
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            {/* form */}
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="emailaddress" className="form-label">Email address</label>
                                    <input className="form-control" type="text" id="emailaddress" required placeholder="Enter your email" value={username} onChange={(e) => setUsername(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    {/* <a href="pages-recoverpw-2.html" className="text-muted float-end"><small>Forgot your password?</small></a> */}
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input className="form-control" type="password" required id="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                </div>
                                <div className="d-grid mb-0 text-center">
                                    <button className="btn btn-primary" type="submit"><i className="mdi mdi-login" /> Log In </button>
                                </div>

                            </form>
                            {/* end form*/}
                        </div>
                        {/* Footer*/}
                        {/* <footer className="footer footer-alt">
                            <p className="text-muted">Don't have an account? <a href="pages-register-2.html" className="text-muted ms-1"><b>Sign Up</b></a></p>
                        </footer> */}
                    </div> {/* end .card-body */}
                </div>
                {/* end auth-fluid-form-box*/}
                {/* Auth fluid right content */}
                <div className="auth-fluid-right text-center">
                    
                </div>
                {/* end Auth fluid right content */}
            </div>
            {/* end auth-fluid*/}

        </div>
    )
}

export default Login
